export default "__VITE_ASSET__egy3qUn0__"